import { useClient } from "@/composables/useClient";
import { deserializeCbiDto, serializeCbiDto, encodeRequestParam } from "../serialization/CbiDateCodec";
import type { JobHealthApi } from "../../api/JobHealthApi";
import type { JobHealthHistoryRequest } from "../../generated/dto/JobHealthHistoryRequest";
import type { JobHealthSnapshot } from "../../generated/dto/JobHealthSnapshot";
import type { JobMachineStaff } from "../../generated/dto/JobMachineStaff";
import type { JobRunStaff } from "../../generated/dto/JobRunStaff";
import type { JobScheduleStaff } from "../../generated/dto/JobScheduleStaff";

export class JobHealthApiClient implements JobHealthApi {
  constructor(private readonly client = useClient()) {}

  async getJobMachineStaff(id: number): Promise<JobMachineStaff> {
    const { data } = await this.client.get<unknown>(`/jobmachine/staff/${id}`);
    return deserializeCbiDto<JobMachineStaff>(data, "generated.dto.JobMachineStaff");
  }

  async getJobScheduleStaff(id: number): Promise<JobScheduleStaff> {
    const { data } = await this.client.get<unknown>(`/jobschedule/staff/${id}`);
    return deserializeCbiDto<JobScheduleStaff>(data, "generated.dto.JobScheduleStaff");
  }

  async getJobRunStaff(id: number): Promise<JobRunStaff> {
    const { data } = await this.client.get<unknown>(`/jobrun/staff/${id}`);
    return deserializeCbiDto<JobRunStaff>(data, "generated.dto.JobRunStaff");
  }

  async historyStaff(request: JobHealthHistoryRequest): Promise<Array<JobRunStaff>> {
    const { data } = await this.client.post<unknown>(`/jobhealth/staff/history`, serializeCbiDto(request, "generated.dto.JobHealthHistoryRequest"));
    return deserializeCbiDto<Array<JobRunStaff>>(data, "generated.dto.JobRunStaff");
  }

  async statusStaff(): Promise<JobHealthSnapshot> {
    const { data } = await this.client.post<unknown>(`/jobhealth/staff/status`);
    return deserializeCbiDto<JobHealthSnapshot>(data, "generated.dto.JobHealthSnapshot");
  }
}

export const useJobHealthApi = (): JobHealthApi => new JobHealthApiClient();
